export const homepageLinkedData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Not On The High Street',
  alternateName: 'NOTHS',
  url: 'https://www.notonthehighstreet.com',
  logo: 'https://cdn.notonthehighstreet.com/images/header/logos/tag_logo_uk_v2.png',
  sameAs: [
    'https://www.facebook.com/notonthehighstreet',
    'https://twitter.com/notonthehighst',
    'https://instagram.com/notonthehighstreet',
    'https://www.linkedin.com/company/notonthehighstreet-com',
    'https://pinterest.com/notonthehighst/',
    'https://www.notonthehighstreet.com',
  ],
};
